/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { CameraFilled } from '@ant-design/icons';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Form } from 'antd';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import createIncomingPurchaseInvoiceApi from '../../../apis/store-apis/incoming-purchas-invoices-apis/CreateIncomingPurchaseInvoiceApi';
import AntdRadioGroup from '../../../common/antd-form-components/AntdRadioGroup';
import AntdSelectOption from '../../../common/antd-form-components/AntdSelectOption';
import AntdTextField from '../../../common/antd-form-components/AntdTextField';
import AntdTextarea from '../../../common/antd-form-components/AntdTextarea';
import CustomAntdDatePicker from '../../../common/antd-form-components/CustomAntdDatePicker';
import MyDropZone from '../../../common/dorp-zone/MyDropZone';
import MyDropZonePreview from '../../../common/dorp-zone/MyDropZonePreview';
import {
  default as IncomingPurchaseInvoiceContext,
  default as StoreReceiptContext
} from '../../../contexts/incoming-purchase-invoice-context/IncomingPurchaseInvoiceContext';
import UserContext from '../../../contexts/user-context/UserProvider';
import useCustomApiRequest from '../../../custom-hooks/useCustomApiRequest';
import useIngredients from '../../../custom-hooks/useIngredients';
import useSuppliers from '../../../custom-hooks/useSuppliers';
import useSystemSettings from '../../../custom-hooks/useSystemSettings';
import useWarehouses from '../../../custom-hooks/useWarehouses';
import errorNotification from '../../../utils/errorNotification';
import successNotification from '../../../utils/successNotification';
import renderIngredientsFields from '../price-offer-page-new/renderIngredientFieldsProducts';
import RenderProductsFieldsProducts from './RenderProductsFieldsProducts';
import {
  renderFieldsTotalValue,
  // renderReceiptTotalValueAfterTax,
  renderTotalPriceAfterExtraPrices
} from './receiptCalculations';
import renderExtraPricesFields from './renderExtraPricesFields';
import './tableFormProduct.scss';
import getIncommingInvoiceSchema from './tableSchemaProducts';

const TableFormProducts = () => {
  const systemSettings = useSystemSettings();
  const {
    setIsLoading,
    setModalOpened,
    setFetchCount,
    selectedReceipt,
    isSubmittingForm,
    setIsSubmittingForm,
    setFilterValues
  } = useContext(StoreReceiptContext);

  const { allProducts } = useContext(IncomingPurchaseInvoiceContext);

  const { allSuppliers } = useSuppliers();
  // const { allProducts } = useProducts();
  // console.log(allProducts)

  const allIngredients = useIngredients();
  const allWarehouses = useWarehouses();
  const { user } = useContext(UserContext);
  const { t } = useTranslation();

  const {
    control,
    setValue,
    handleSubmit,
    reset,
    watch,
    register,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(getIncommingInvoiceSchema(selectedReceipt, t)),
    mode: 'all',
    defaultValues: {
      manualNum: '',
      supplier_id: '',
      products: [
        {
          product_id: '',
          returnQuantity: '',
          quantity: '',
          warehouse_id: '',
          expirationDate: '',
          discount_type: 'no_discount',
          discount_price: '',
          discount_percentage: '',
          price: '',
          tax: ''
        }
      ],
      ingredients: [
        {
          ingredient_id: '',
          returnQuantity: '',
          quantity: '',
          warehouse_id: '',
          expirationDate: '',
          discount_type: 'no_discount',
          discount_price: '',
          discount_percentage: '',
          price: '',
          tax: ''
        }
      ],
      details_type: '1',
      due_date: null,
      //
      discount_type: 'no_discount', // => 1 is fixed price && 2 is percentage price
      discount_price: '',
      discount_percentage: '',
      invoice_due_date: '',
      first_paid: 0,
      first_pay_type: '',
      first_pay_img: '',
      invoice_image: '',
      //
      // extra_prices: [
      //   {
      //     price: '',
      //     title: ''
      //   }
      // ],
      //
      pay_type: '',

      //
      note: ''
    }
  });
  const {
    fields: productsFields,
    append: appendProductField,
    remove: removeProductField
  } = useFieldArray({
    control,
    name: 'products'
  });
  const {
    fields: ingredientsFields,
    append: appendIngredientField,
    remove: removeIngredientField
  } = useFieldArray({
    control,
    name: 'ingredients'
  });
  const {
    fields: extraPricesFields,
    append: appendExtraPriceField,
    remove: removeExtraPriceField
  } = useFieldArray({
    control,
    name: 'extra_prices'
  });
  const {
    fields: installmentsFields,
    append: appendInstallmentField,
    remove: removeInstallmentField
  } = useFieldArray({
    control,
    name: 'installments'
  });

  const [receiptRadiosArr, setReceiptRadiosArr] = React.useState([]);
  useEffect(() => {
    if (selectedReceipt?.detailsType == '1') {
      setReceiptRadiosArr([
        {
          title: t('purchaseInvoices.products'),
          value: '1'
        }
      ]);
    }
    //  else if (selectedReceipt?.detailsType == '2') {
    //   setReceiptRadiosArr([
    //     {
    //       title: 'مكونات منتجات',
    //       value: '2'
    //     }
    //   ]);
    // }
    else {
      setReceiptRadiosArr([
        {
          title: t('purchaseInvoices.products'),
          value: '1'
        }
        // {
        //   title: 'مكونات منتجات',
        //   value: '2'
        // }
      ]);
    }
  }, [selectedReceipt]);

  let [paymentMethods, setPaymentStatus] = useState([]);
  useEffect(() => {
    if (selectedReceipt) {
      systemSettings?.invoiceSetting?.payment_methods_objects.map(
        (paymentMethod) => {
          paymentMethod.id != 2 &&
            paymentMethod.id != 6 &&
            setPaymentStatus((prv) => [
              ...prv,
              { title: paymentMethod.name, value: paymentMethod.id }
            ]);
        }
      );
    } else {
      systemSettings?.invoiceSetting?.payment_methods_objects.map(
        (paymentMethod) => {
          setPaymentStatus((prv) => [
            ...prv,
            { title: paymentMethod.name, value: paymentMethod.id }
          ]);
        }
      );
    }
  }, [systemSettings]);

  const [invoiceFileToUpload, setInvoiceFileToUpload] = useState(
    watch('invoice_image') ? watch('invoice_image') : null
  );
  const [invoiceFileToUploadDefferd, setInvoiceFileToUploadDefferd] = useState(
    watch('first_pay_img') ? watch('first_pay_img') : null
  );
  useEffect(() => {
    setValue('invoice_image', invoiceFileToUpload);
    if (watch('invoice_image')) {
      clearErrors('invoice_image');
    }
  }, [invoiceFileToUpload, invoiceFileToUpload?.length]);
  useEffect(() => {
    setValue('first_pay_img', invoiceFileToUploadDefferd);
    if (watch('first_pay_img')) {
      clearErrors('first_pay_img');
    }
  }, [invoiceFileToUploadDefferd, invoiceFileToUploadDefferd?.length]);

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  const handleFilesDrop = async (acceptedFiles, formFiles, setFormFiles) => {
    const duplicates = [];
    for (let i of acceptedFiles) {
      if (formFiles?.length) {
        for (let f of formFiles) {
          if (i.name === f.name) {
            duplicates.push(i);
          }
        }
      }
    }
    for (let i = 0; i < acceptedFiles.length; i++) {
      for (let f of duplicates) {
        if (acceptedFiles[i].name === f.name) {
          acceptedFiles.splice(i, 1);
        }
      }
    }
    acceptedFiles.forEach(async (file) => {
      const preview = await getBase64(file);
      Object.assign(file, {
        preview
      });
      setFormFiles((prevState) => [file]);
      if (formFiles?.length > 0) {
        setFormFiles((currState) => [file]);
      } else {
        setFormFiles([file]);
      }
    });
  };

  const clearFileFromUpload = (file, setFilesToUpload) => {
    setFilesToUpload((prevState) => {
      const filtered = prevState.filter((asset) => asset.name !== file.name);
      if (filtered?.length === 0) return null;
      return filtered;
    });
  };
  useEffect(() => {
    if (watch('pay_type')) {
      setValue('invoice_due_date', '');
      clearErrors('invoice_due_date');
      setValue('first_paid', 0);
      clearErrors('first_paid');
      setValue('first_pay_type', '');
      clearErrors('first_pay_type');
      setValue('invoice_image', null);
      clearErrors('invoice_image');
      setValue('first_pay_img', null);
      clearErrors('first_pay_img');
      setInvoiceFileToUpload(null);
    }
  }, [watch('pay_type')]);
  useEffect(() => {
    setValue('first_pay_img', null);
    clearErrors('first_pay_img');
  }, [watch('first_pay_type')]);
  useEffect(() => {
    if (watch('multiPaymentCash')) {
      clearErrors('multiPaymentVisa');
    }
  }, [watch('multiPaymentCash')]);
  useEffect(() => {
    if (watch('multiPaymentVisa')) {
      clearErrors('multiPaymentCash');
    }
  }, [watch('multiPaymentVisa')]);

  useEffect(() => {
    if (renderFieldsTotalValue(watch('products'))) {
      clearErrors('multiPaymentCash');
      clearErrors('multiPaymentVisa');
      setValue('multiPaymentCash', '');
      setValue('multiPaymentVisa', '');
    }
  }, [renderFieldsTotalValue(watch('products'))]);
  const customApiRequest = useCustomApiRequest();
  const onSubmit = async (data) => {
    const mappedData = {};
    if (data.manualNum) mappedData.manualNum = data.manualNum;
    if (data.supplier_id) mappedData.supplier_id = data.supplier_id;
    if (data.note) mappedData.note = data.note;
    if (data.due_date)
      mappedData.dueDate = moment(data.due_date).format('YYYY-MM-DD');
    if (data.details_type) mappedData.detailsType = data.details_type;
    /////////////////

    if (data.products?.length > 0 && data.details_type === '1') {
      // prdoucts
      let mappedProducts = data.products.map((pro) => {
        if (
          pro.product_id &&
          (pro.discount_type == '1' || pro.discount_type == '2')
        )
          return {
            id: pro.product_id,
            quantity: selectedReceipt ? pro.returnQuantity : pro.quantity,
            stock_id: pro.warehouse_id,
            discountType: pro.discount_type,
            discountValue:
              pro.discount_type === '1'
                ? pro.discount_price
                : pro.discount_percentage,
            expirationDate: pro.expirationDate
              ? moment(pro.expirationDate).format('YYYY-MM-DD')
              : null,
            price: pro.price ? pro.price : '',
            tax: pro.tax,
            including_tax: pro?.including_tax
          };
        else if (
          pro.product_id &&
          !(pro.discount_type == '1' || pro.discount_type == '2')
        )
          return {
            id: pro.product_id,
            quantity: selectedReceipt ? pro.returnQuantity : pro.quantity,
            stock_id: pro.warehouse_id,
            expirationDate: pro.expirationDate
              ? moment(pro.expirationDate).format('YYYY-MM-DD')
              : null,
            price: pro.price ? pro.price : '',
            tax: pro.tax,
            including_tax: pro?.including_tax
          };
        return null;
      });

      if (selectedReceipt) {
        mappedProducts = data.products.map((pro, index) => {
          if (
            pro.product_id &&
            (pro.discount_type == '1' || pro.discount_type == '2')
          )
            return {
              id: pro.product_id,
              quantity: selectedReceipt ? pro.returnQuantity : pro.quantity,
              parent_quantity:
                selectedReceipt?.details?.length > 0
                  ? selectedReceipt.details[index]?.quantity
                  : 0,
              stock_id: pro.warehouse_id,
              discountType: pro.discount_type,
              discountValue:
                pro.discount_type === '1'
                  ? pro.discount_price
                  : pro.discount_percentage,
              expirationDate: pro.expirationDate
                ? moment(data.expirationDate).format('YYYY-MM-DD')
                : null,
              price: pro.price ? pro.price : '',
              tax: pro.tax,
              including_tax: pro?.including_tax
            };
          else if (
            pro.product_id &&
            !(pro.discount_type == '1' || pro.discount_type == '2')
          )
            return {
              id: pro.product_id,
              quantity: selectedReceipt ? pro.returnQuantity : pro.quantity,
              parent_quantity:
                selectedReceipt?.details?.length > 0
                  ? selectedReceipt.details[index]?.quantity
                  : 0,
              stock_id: pro.warehouse_id,
              expirationDate: pro.expirationDate
                ? moment(data.expirationDate).format('YYYY-MM-DD')
                : null,
              price: pro.price ? pro.price : '',
              tax: pro.tax,
              including_tax: pro?.including_tax
            };
          return null;
        });
      }
      if (mappedProducts?.length > 0 && mappedProducts[0] !== null) {
        mappedData.details = JSON.stringify(mappedProducts);
      }
    }

    /////////////////

    if (data.ingredients?.length > 0 && data.details_type == '2') {
      // ingredients
      let mappedIngredients = data.ingredients.map((ing) => {
        if (
          ing.ingredient_id &&
          (ing.discount_type == '1' || ing.discount_type == '2')
        )
          return {
            id: ing.ingredient_id,
            quantity: ing.quantity,
            stock_id: ing.warehouse_id,
            discountType: ing.discount_type,
            discountValue:
              ing.discount_type === '1'
                ? ing.discount_price
                : ing.discount_percentage,
            expirationDate: ing.expirationDate
              ? moment(data.expirationDate).format('YYYY-MM-DD')
              : null,
            price: ing.price ? ing.price : '',
            tax: ing.tax
          };
        else if (
          ing.ingredient_id &&
          !(ing.discount_type == '1' || ing.discount_type == '2')
        )
          return {
            id: ing.ingredient_id,
            quantity: ing.quantity,
            stock_id: ing.warehouse_id,
            expirationDate: ing.expirationDate
              ? moment(data.expirationDate).format('YYYY-MM-DD')
              : null,
            price: ing.price ? ing.price : '',
            tax: ing.tax
          };

        return null;
      });
      if (selectedReceipt) {
        mappedIngredients = data.ingredients.map((ing, index) => {
          if (
            ing.ingredient_id &&
            (ing.discount_type == '1' || ing.discount_type == '2')
          )
            return {
              id: ing.ingredient_id,
              quantity: ing.quantity,
              parent_quantity:
                selectedReceipt?.details?.length > 0
                  ? selectedReceipt.details[index]?.quantity
                  : 0,
              stock_id: ing.warehouse_id,
              discountType: ing.discount_type,
              discountValue:
                ing.discount_type === '1'
                  ? ing.discount_price
                  : ing.discount_percentage,
              expirationDate: ing.expirationDate
                ? moment(data.expirationDate).format('YYYY-MM-DD')
                : null,
              price: ing.price ? ing.price : '',
              tax: ing.tax
            };
          else if (
            ing.ingredient_id &&
            !(ing.discount_type == '1' || ing.discount_type == '2')
          )
            return {
              id: ing.ingredient_id,
              quantity: ing.quantity,
              parent_quantity:
                selectedReceipt?.details?.length > 0
                  ? selectedReceipt.details[index]?.quantity
                  : 0,
              stock_id: ing.warehouse_id,
              expirationDate: ing.expirationDate
                ? moment(data.expirationDate).format('YYYY-MM-DD')
                : null,
              price: ing.price ? ing.price : '',
              tax: ing.tax
            };

          return null;
        });
      }

      if (mappedIngredients?.length > 0 && mappedIngredients[0] !== null) {
        mappedData.details = JSON.stringify(mappedIngredients);
      }
    }
    /////////////////

    mappedData.type = 1; // => buy receipt type
    mappedData.invoice_type = 1; //  1 => incoming purchase invoice, 2 => outgoing purchase invoice
    /////////////////
    if (data.extra_prices?.length > 0) {
      const mappedExtraPrices = data.extra_prices.map((extra) => {
        if (extra.price && extra.title) {
          return {
            price: extra.price,
            desc: extra.title
          };
        }
        return null;
      });
      if (mappedExtraPrices?.length > 0 && mappedExtraPrices[0] !== null) {
        mappedData.addPrices = JSON.stringify(mappedExtraPrices);
      }
    }
    /////////////////
    if (data.discount_type) {
      if (data.discount_type == '1' || data.discount_type == '2') {
        mappedData.discountType = data.discount_type;
      }
      if (data.discount_price && data.discount_type === '1') {
        mappedData.discountValue = data.discount_price;
      } else if (data.discount_percentage && data.discount_type === '2') {
        mappedData.discountValue = data.discount_percentage;
      }
    }
    /////////////
    if (data.pay_type) {
      mappedData.paymentType = data.pay_type;
      if (data.pay_type == '2') {
        // const mappedInstallments = data.installments.map((ins) => {
        //   return {
        //     price: ins.price ? ins.price : null,
        //     note: ins.note ? ins.note : null,
        //     date: ins.date ? moment(ins.date).format('YYYY-MM-DD') : null,
        //     status: ins.status ? ins.status : null
        //   };
        // });
        // if (mappedInstallments?.length > 0 && mappedInstallments[0] !== null) {
        //   mappedData.installments = JSON.stringify(mappedInstallments);
        // }

        if (data?.invoice_due_date) {
          mappedData.invoice_due_date = moment(data.invoice_due_date).format(
            'YYYY-MM-DD'
          );
        }
        mappedData.first_paid = data.first_paid ? data.first_paid : 0;
        if (data?.first_pay_type) {
          mappedData.first_pay_type = data.first_pay_type;
          if (data?.first_pay_type == '5') {
            if (data?.first_pay_img?.length) {
              mappedData.first_pay_img = data.first_pay_img[0];
            }
          }
        }
        if (renderFieldsTotalValue(watch('products'))) {
          mappedData.deferred = renderFieldsTotalValue(watch('products'));
        }
      } else if (mappedData.paymentType == '5') {
        if (data?.invoice_image?.length) {
          mappedData.bank_image = data.invoice_image[0];
        }
        if (renderFieldsTotalValue(watch('products'))) {
          mappedData.bank = renderFieldsTotalValue(watch('products'));
        }
      } else if (mappedData.paymentType == '6') {
        mappedData.totalInvoicePrice = renderFieldsTotalValue(
          watch('products')
        );
        if (data?.multiPaymentVisa) {
          mappedData.visa = data.multiPaymentVisa;
        }
        if (data?.multiPaymentCash) {
          mappedData.cash = data.multiPaymentCash;
        }
      }
    }

    setIsSubmittingForm(true);
    setIsLoading(true);
    if (selectedReceipt) {
      mappedData.parentInvoice = selectedReceipt.id;
      mappedData.type = 2; // => 2 is the type of return receipt
      const formData = new FormData();
      for (let key in mappedData) {
        formData.append(key, mappedData[key]);
      }
      customApiRequest(
        createIncomingPurchaseInvoiceApi(user?.token, formData, true),
        (res) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          if (res?.status === 200 && res?.data?.data) {
            setModalOpened(false);
            setFetchCount((prevState) => prevState + 1);
            successNotification({
              title: t('purchaseInvoices.successNotification'),
              message: t('purchaseInvoices.invoiceReturned')
            });
          } else {
            errorNotification({
              title: t('purchaseInvoices.errorOccurred'),
              message: res?.data?.message
                ? res.data.message
                : t('purchaseInvoices.tryLaterMessage')
            });
          }
        },
        (error) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          errorNotification({
            title: 'Something went wrong',
            message: error?.response?.data?.message || 'Try again later'
          });
        }
      );
    } else {
      const formData = new FormData();
      for (let key in mappedData) {
        formData.append(key, mappedData[key]);
      }
      customApiRequest(
        createIncomingPurchaseInvoiceApi(user?.token, formData),
        (res) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          if (res?.status === 200 && res?.data?.data) {
            setModalOpened(false);
            setFetchCount((prevState) => prevState + 1);
            successNotification({
              title: t('purchaseInvoices.successNotification'),
              message: t('purchaseInvoices.invoiceAddedSuccessfully')
            });
          } else {
            errorNotification({
              title: t('purchaseInvoices.errorOccurred'),
              message: res?.data?.message
                ? res.data.message
                : t('purchaseInvoices.tryLaterMessage')
            });
          }
        },
        (error) => {
          setIsSubmittingForm(false);
          setIsLoading(false);
          errorNotification({
            title: 'Something went wrong',
            message: error?.response?.data?.message || 'Try again later'
          });
        }
      );
    }
  };
  // console.log('selectedReceipt', selectedReceipt);

  // handle initial values
  useEffect(() => {
    if (selectedReceipt) {
      if (selectedReceipt?.supplier?.id) {
        setValue('supplier_id', String(selectedReceipt.supplier.id));
      }
      if (selectedReceipt?.manualNum) {
        setValue('manualNum', selectedReceipt.manualNum);
      }
      if (selectedReceipt?.dueDate)
        setValue('due_date', moment(selectedReceipt.dueDate, 'YYYY-MM-DD'));
      if (selectedReceipt?.note) {
        setValue('note', selectedReceipt.note);
      }
      //
      if (selectedReceipt?.detailsType) {
        setValue('details_type', String(selectedReceipt.detailsType));
      }
      //
      if (selectedReceipt?.discountType) {
        if (
          selectedReceipt.discountType == '1' ||
          selectedReceipt.discountType == '2'
        ) {
          // 1 => fixed price discount
          // 2 => percentage discount
          setValue('discount_type', String(selectedReceipt.discountType));
        } else {
          setValue('discount_type', 'no_discount');
        }
      } else {
        setValue('discount_type', 'no_discount');
      }
      //
      if (
        String(selectedReceipt.discountValue) &&
        selectedReceipt.discountType == '1'
      ) {
        setValue('discount_price', selectedReceipt.discountValue);
      } else if (
        String(selectedReceipt.discountValue) &&
        selectedReceipt.discountType == '2'
      ) {
        setValue('discount_percentage', selectedReceipt.discountValue);
      }
      if (
        selectedReceipt?.paymentType &&
        selectedReceipt?.paymentType != 2 &&
        selectedReceipt?.paymentType != 6
      ) {
        setValue('pay_type', String(selectedReceipt.paymentType));
      }
      if (selectedReceipt?.paymentType == '5') {
        if (selectedReceipt?.bankName) {
          setValue('bankAccount.accountNumber', selectedReceipt.bankName);
        }
        if (selectedReceipt?.cheekNum) {
          setValue('bankAccount.price', selectedReceipt.cheekNum);
        }
      }
      //
    }
    /////////////////////////
    if (selectedReceipt) {
      // const { products, ingredients, extraPrices, installments } =
      //   selectedReceipt;

      const sharedReset = {
        manualNum: selectedReceipt?.manualNum ? selectedReceipt.manualNum : '',
        supplier_id: selectedReceipt?.supplier?.id
          ? String(selectedReceipt.supplier.id)
          : '',
        due_date: selectedReceipt.dueDate
          ? moment(selectedReceipt.dueDate, 'YYYY-MM-DD')
          : null,
        note: selectedReceipt.note,
        details_type: selectedReceipt.detailsType
          ? String(selectedReceipt.detailsType)
          : '',
        //
        discount_type: selectedReceipt.discountType
          ? String(selectedReceipt.discountType)
          : 'no_discount',
        discount_price:
          selectedReceipt?.discountType == '1' &&
          String(selectedReceipt.discountValue)
            ? selectedReceipt.discountValue
            : '',
        discount_percentage:
          selectedReceipt?.discountType == '2' &&
          String(selectedReceipt.discountValue)
            ? selectedReceipt.discountValue
            : '',
        //
        pay_type: selectedReceipt.paymentType
          ? selectedReceipt.paymentType != 2 && selectedReceipt.paymentType != 6
            ? String(selectedReceipt.paymentType)
            : ''
          : '',
        bankAccount: {
          accountNumber:
            selectedReceipt?.bankName && selectedReceipt?.paymentType == '5'
              ? selectedReceipt.bankName
              : '',
          price:
            selectedReceipt?.cheekNum && selectedReceipt?.paymentType == '5'
              ? selectedReceipt.cheekNum
              : ''
        }
      };
      if (selectedReceipt.details?.length > 0) {
        const { details } = selectedReceipt;
        let mappedProducts = [];
        let mappedIngredients = [];
        let mappedInstallments = [];
        if (selectedReceipt?.detailsType == '1') {
          mappedProducts = details.map((product) => ({
            product_id: String(product.model_id),
            quantity: product.quantity,
            warehouse_id: product.stock?.id ? String(product.stock.id) : '',
            expirationDate: product.expirationDate
              ? moment(product.expirationDate, 'YYYY-MM-DD')
              : null,
            discount_type: product.discountType
              ? String(product.discountType)
              : 'no_discount',
            discount_price:
              product?.discountType == '1' && String(product.discountValue)
                ? product.discountValue
                : '',
            discount_percentage:
              product?.discountType == '2' && String(product.discountValue)
                ? product.discountValue
                : '',
            price: product?.price ? product.price : '',
            tax: parseFloat(product?.tax) > 0 ? product.tax : '0'
          }));
        } else if (selectedReceipt?.detailsType == '2') {
          mappedIngredients = details.map((ingredient) => ({
            ingredient_id: String(ingredient.model_id),
            quantity: ingredient.quantity,
            warehouse_id: ingredient.stock?.id
              ? String(ingredient.stock.id)
              : '',
            expirationDate: ingredient.expirationDate
              ? moment(ingredient.expirationDate, 'YYYY-MM-DD')
              : null,
            discount_type: ingredient.discountType
              ? String(ingredient.discountType)
              : 'no_discount',
            discount_price:
              ingredient?.discountType == '1' &&
              String(ingredient.discountValue)
                ? ingredient.discountValue
                : '',
            discount_percentage:
              ingredient?.discountType == '2' &&
              String(ingredient.discountValue)
                ? ingredient.discountValue
                : '',
            price: ingredient?.price ? ingredient.price : '',
            tax: parseFloat(ingredient?.tax) > 0 ? ingredient.tax : '0'
          }));
        }
        //

        const mappedExtraPrices =
          selectedReceipt?.addPrices?.length > 0 &&
          selectedReceipt.addPrices.map((obj) => ({
            price: obj.price,
            title: obj.desc
          }));

        if (
          selectedReceipt.paymentType == '2' &&
          selectedReceipt.Installment?.length > 0
        ) {
          mappedInstallments = selectedReceipt.Installment.map((ins) => ({
            price: ins.price,
            //  status: String(ins.status),
            note: ins.note,
            date: moment(ins.date, 'YYYY-MM-DD')
          }));
        }

        reset({
          ...sharedReset,
          products: details?.length > 0 ? [...mappedProducts] : [],
          ingredients: details?.length > 0 ? [...mappedIngredients] : [],
          extra_prices:
            selectedReceipt?.addPrices?.length > 0
              ? [...mappedExtraPrices]
              : [],
          installments:
            selectedReceipt.Installment?.length > 0
              ? [...mappedInstallments]
              : []
        });
      }
    }
  }, [selectedReceipt, selectedReceipt?.id, reset]);

  const [form] = Form.useForm();
  return (
    <Form
      className="create-receipt-form custom-shared-form"
      form={form}
      layout="vertical"
      // initialValues={{
      //   products: watch('products')
      // }}
      fields={[
        {
          name: 'details_type',
          value: watch('details_type')
        },
        {
          name: 'discount_type',
          value: watch('discount_type')
        },
        {
          name: 'pay_type',
          value: watch('pay_type')
        },
        {
          name: 'products',
          value: watch('products')
        },
        {
          name: 'ingredients',
          value: watch('ingredients')
        },
        {
          name: 'installments',
          value: watch('installments')
        }
      ]}
      onFinish={handleSubmit(onSubmit)}
    >
      <div className="form-body">
        {selectedReceipt && (
          <div className="supplier-name-view">
            <span>{t('purchaseInvoices.InvoiceSupplier')} : </span>
            <span className="supp-name">{selectedReceipt.supplier?.name}</span>
          </div>
        )}
        <div className="text-field-label-wrap">
          <p className="label-p">{t('purchaseInvoices.invoiceNumber')}</p>
          <div className="text-field-wrap">
            <AntdTextField
              // disabled={selectedReceipt ? true : false}
              className="form-text-field"
              name="manualNum"
              type="text"
              placeholder={t('purchaseInvoices.invoiceNumberPlaceholder')}
              errorMsg={errors?.manualNum && errors.manualNum.message}
              validateStatus={errors?.manualNum ? 'error' : ''}
              control={control}
            />
          </div>
        </div>

        {!selectedReceipt && (
          <div className="select-label-wrap">
            <p className="label-p">{t('purchaseInvoices.chooseMerchant')}</p>
            <div className="custom-select-wrap without-icon">
              <AntdSelectOption
                name="supplier_id"
                errorMsg={errors?.supplier_id?.message}
                validateStatus={errors?.supplier_id ? 'error' : ''}
                control={control}
                setValue={setValue}
                placeholder={t('purchaseInvoices.chooseMerchant')}
                options={
                  allSuppliers?.length > 0 &&
                  allSuppliers.map((supp) => ({
                    title: supp.name,
                    value: String(supp.id)
                  }))
                }
                showSearch={true}
                // onSearch={onSearch}
                filterOption={(input, option) =>
                  option.children.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                formClassName="create-receipt-form"
              />
            </div>
          </div>
        )}

        <div className="date-picker-wrap">
          <p className="label-p">
            {t('purchaseInvoices.issuingInvoiceDate')} ( DD / MM / YYYY )
          </p>
          <CustomAntdDatePicker
            // disablePast
            control={control}
            name="due_date"
            className="receipt-date-picker"
            formClassName="create-receipt-form"
            // disablePast={true}
          />
          {errors?.due_date && (
            <p className="error-p">{errors.due_date.message}</p>
          )}
        </div>

        <div className="text-field-label-wrap">
          <p className="label-p">{t('purchaseInvoices.notes')}</p>
          <div className="text-field-wrap">
            <AntdTextarea
              className="form-text-area"
              name="note"
              rows={8}
              placeholder={t('purchaseInvoices.notesPlaceholder')}
              errorMsg={errors?.note?.message}
              validateStatus={errors?.note ? 'error' : ''}
              control={control}
            />
          </div>
        </div>

        <div
          className="radios-field-array-wrap no-border"
          style={{ marginBottom: 0 }}
        >
          <AntdRadioGroup
            name="details_type"
            className="form-radio-group"
            control={control}
            label={t('purchaseInvoices.SelectInvoiceType')}
            validateStatus={errors?.details_type ? 'error' : ''}
            errorMsg={errors?.details_type?.message}
            radios={receiptRadiosArr}
          />

          {String(watch('details_type')) == '1' && (
            <div className="products-add-btn-wrap">
              <RenderProductsFieldsProducts
                allProducts={allProducts}
                allWarehouses={allWarehouses}
                productsFields={productsFields}
                removeProductField={removeProductField}
                selectedReceipt={selectedReceipt}
                watch={watch}
                errors={errors}
                setValue={setValue}
                control={control}
                register={register}
                systemSettings={systemSettings}
                setFilterValues={setFilterValues}
                setFetchCount={setFetchCount}
              />

              {watch('products')?.length > 0 &&
                watch(`products[0].product_id`) && (
                  <div className="total-fields-price">
                    <span className="total-title">
                      {t('purchaseInvoices.ProductsPrice')} :{' '}
                    </span>
                    <span className="total-value">
                      {renderFieldsTotalValue(
                        watch('products'),
                        1,
                        systemSettings?.tax
                      )}
                    </span>
                  </div>
                )}
            </div>
          )}

          {String(watch('details_type')) === '2' && (
            <div className="ingredients-add-btn-wrap">
              <div
                className="add-new-field-btn"
                style={{
                  marginBottom: 12
                }}
                onClick={() =>
                  appendIngredientField({
                    ingredient_id: '',
                    quantity: '',
                    warehouse_id: '',
                    expirationDate: '',
                    discount_type: '',
                    discount_price: '',
                    discount_percentage: '',
                    price: '',
                    tax: '0'
                  })
                }
              >
                <span>{t('purchaseInvoices.newIngredient')}</span>
              </div>
              {renderIngredientsFields(
                watch,
                allIngredients,
                allWarehouses,
                control,
                setValue,
                errors,
                ingredientsFields,
                removeIngredientField,
                selectedReceipt,
                systemSettings
              )}
              {watch('ingredients')?.length > 0 &&
                watch(`ingredients[0].ingredient_id`) && (
                  <div className="total-fields-price">
                    <span className="total-title">
                      {t('purchaseInvoices.ingredientsPrice')}
                    </span>
                    <span className="total-value">
                      {renderFieldsTotalValue(watch('ingredients'))}
                    </span>
                  </div>
                )}
            </div>
          )}
        </div>
        {/* //////////////////////////////// */}
        <div
          /*  style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: '10px'
          }} */
          className="newPriceContainer"
        >
          {/* extra prices section */}
          {/* {(watch('details_type') == '1' || watch('details_type') == '2') && (
            <div
              //  style={{
              //   borderTop: '1px solid rgba(0, 0, 0, .1)'
              // }} 
              className="newPriceContainerCon"
            >
              <div
                className="add-new-field-btn"
                onClick={() =>
                  appendExtraPriceField({
                    price: '',
                    title: ''
                  })
                }
              >
                <span> + {t('purchaseInvoices.newExtraPrice')}</span>
              </div>

              {watch('extra_prices')?.length > 0 &&
                watch(`extra_prices[0].price`) && (
                  <div className="total-fields-price">
                    <span className="total-title">
                      {t('purchaseInvoices.priceAfterExtras')} :{' '}
                    </span>
                    <span className="total-value">
                      {renderTotalPriceAfterExtraPrices(
                        watch('details_type'),
                        watch('products'),
                        watch('ingredients'),
                        watch('extra_prices')
                      )}
                    </span>
                  </div>
                )}
            </div>
          )} */}

          {/* ./extra prices section */}

          {/* add new price */}
          {!selectedReceipt && (
            <div
              className="add-new-field-btn"
              onClick={() =>
                appendProductField({
                  product_id: '',
                  quantity: '',
                  warehouse_id: '',
                  expirationDate: '',
                  discount_type: 'no_discount',
                  discount_price: '',
                  discount_percentage: '',
                  price: '',
                  tax: ''
                })
              }
            >
              {}
              <span>{t('purchaseInvoices.newProduct')}</span>
            </div>
          )}
          {/* ./add new price */}
        </div>
        <div>
          {renderExtraPricesFields(
            control,
            setValue,
            errors,
            extraPricesFields,
            removeExtraPriceField,
            t
          )}
        </div>
        {/* paytype section */}
        {(watch('details_type') == '1' || watch('details_type') == '2') && (
          <div
            className="radios-field-array-wrap no-border"
            style={{ paddingBottom: '22px' }}
          >
            <AntdRadioGroup
              name="pay_type"
              className="form-radio-group"
              control={control}
              label={t('purchaseInvoices.choosePayType')}
              validateStatus={errors?.pay_type ? 'error' : ''}
              errorMsg={errors?.pay_type?.message}
              radios={paymentMethods}
              // isRadioButton
            />

            {!selectedReceipt && String(watch('pay_type')) == '2' && (
              <div
                className="ingredients-add-btn-wrap"
                style={{
                  display: 'grid',
                  alignItems: 'start',
                  gridTemplateColumns: '1fr 1fr',
                  width: '100%',
                  gap: '0 30px'
                }}
              >
                <div className="date-picker-wrap">
                  <p style={{ marginBottom: '8px' }}>
                    {t('purchaseInvoices.dateOfPayment')} ( DD / MM / YYYY )
                  </p>
                  <CustomAntdDatePicker
                    // disablePast
                    control={control}
                    name={`invoice_due_date`}
                    className="receipt-date-picker"
                    formClassName="create-receipt-form"
                    errorMsg={
                      errors?.invoice_due_date &&
                      errors.invoice_due_date.message
                    }
                    validateStatus={errors?.invoice_due_date ? 'error' : ''}
                    setValue={setValue}
                    disablePast={true}
                  />
                </div>
                <div className="text-field-label-wrap">
                  <p className="label-p">
                    {t('purchaseInvoices.firstPayment')}
                  </p>
                  <div className="text-field-wrap">
                    <AntdTextField
                      setValue={setValue}
                      className="form-text-field"
                      name={`first_paid`}
                      type="text"
                      placeholder={t(
                        'purchaseInvoices.firstPaymentPlaceholder'
                      )}
                      errorMsg={
                        errors?.first_paid && errors?.first_paid?.message
                      }
                      validateStatus={errors?.first_paid ? 'error' : ''}
                      control={control}
                    />
                  </div>
                </div>
                <div className="text-field-label-wrap">
                  <div className="text-field-wrap">
                    <AntdRadioGroup
                      name="first_pay_type"
                      className="form-radio-group"
                      control={control}
                      label={t('purchaseInvoices.firstPaymentType')}
                      validateStatus={errors?.first_pay_type ? 'error' : ''}
                      errorMsg={errors?.first_pay_type?.message}
                      // radios={paymentMethods}
                      radios={[
                        {
                          title: t('purchaseInvoices.cash'),
                          value: '1'
                        },
                        {
                          title: t('purchaseInvoices.visa'),
                          value: '3'
                        },
                        {
                          title: t('purchaseInvoices.bankTransfer'),
                          value: '5'
                        }
                      ]}
                      // isRadioButton
                    />
                  </div>
                </div>
              </div>
            )}
            {String(watch('first_pay_type')) == '5' && (
              <div className="product-img-wrap">
                <h3 style={{ marginBottom: '6px' }}>
                  {' '}
                  {t('purchaseInvoices.receiptImage')}
                </h3>

                <MyDropZone
                  className="product-header-dropzone"
                  multipleFiles={false}
                  handleFilesDrop={(acceptedFiles) =>
                    handleFilesDrop(
                      acceptedFiles,
                      invoiceFileToUploadDefferd,
                      setInvoiceFileToUploadDefferd
                    )
                  }
                  filesToUpload={invoiceFileToUploadDefferd}
                  id="avatar-input"
                  dropzoneText={t('purchaseInvoices.productImage')}
                  inputName="first_pay_img"
                  icon={<CameraFilled className="dropzone-camera" />}
                  dropZoneUrls={
                    watch('first_pay_img')?.file
                      ? [watch('first_pay_img')?.file]
                      : null
                  }
                >
                  {t('purchaseInvoices.dragImage')}
                </MyDropZone>

                <MyDropZonePreview
                  filesToUpload={invoiceFileToUploadDefferd}
                  clearFileFromUpload={(f) =>
                    clearFileFromUpload(f, setInvoiceFileToUploadDefferd)
                  }
                />
                {errors?.first_pay_img && (
                  <p
                    className="error-p"
                    style={{ color: '#ff4d4f', fontSize: '14px' }}
                  >
                    {errors?.first_pay_img?.message}
                  </p>
                )}
              </div>
            )}
            {String(watch('pay_type')) == '5' && (
              <div className="product-img-wrap">
                <h3 style={{ marginBottom: '6px' }}>
                  {t('purchaseInvoices.receiptImage')}
                </h3>

                <MyDropZone
                  className="product-header-dropzone"
                  multipleFiles={false}
                  handleFilesDrop={(acceptedFiles) =>
                    handleFilesDrop(
                      acceptedFiles,
                      invoiceFileToUpload,
                      setInvoiceFileToUpload
                    )
                  }
                  filesToUpload={invoiceFileToUpload}
                  id="avatar-input"
                  dropzoneText={t('purchaseInvoices.receiptImage')}
                  inputName="invoice_image"
                  icon={<CameraFilled className="dropzone-camera" />}
                  dropZoneUrls={
                    watch('invoice_image')?.file
                      ? [watch('invoice_image')?.file]
                      : null
                  }
                >
                  {t('purchaseInvoices.dragImage')}
                </MyDropZone>

                <MyDropZonePreview
                  filesToUpload={invoiceFileToUpload}
                  clearFileFromUpload={(f) =>
                    clearFileFromUpload(f, setInvoiceFileToUpload)
                  }
                />
                {errors?.invoice_image && (
                  <p
                    className="error-p"
                    style={{ color: '#ff4d4f', fontSize: '14px' }}
                  >
                    {errors?.invoice_image?.message}
                  </p>
                )}
              </div>
            )}

            {!selectedReceipt && String(watch('pay_type')) == '6' && (
              <div className="cheque-wrapper">
                <div className="text-field-label-wrap">
                  <p className="label-p">{t('purchaseInvoices.cash')}</p>
                  <div className="text-field-wrap">
                    <AntdTextField
                      setValue={setValue}
                      className="form-text-field"
                      name={`multiPaymentCash`}
                      type="text"
                      placeholder={t('purchaseInvoices.cashAmount')}
                      errorMsg={
                        errors?.multiPaymentCash &&
                        errors?.multiPaymentCash?.message
                      }
                      validateStatus={errors?.multiPaymentCash ? 'error' : ''}
                      control={control}
                      defaultValue={
                        watch('multiPaymentVisa')
                          ? renderFieldsTotalValue(watch('products')) -
                              parseFloat(watch('multiPaymentVisa')) >
                            0
                            ? Math.ceil(
                                parseFloat(
                                  renderFieldsTotalValue(watch('products')) -
                                    parseFloat(watch('multiPaymentVisa'))
                                ) * 100
                              ) / 100
                            : 0
                          : null
                      }
                    />
                  </div>
                </div>
                <div className="text-field-label-wrap">
                  <p className="label-p">{t('purchaseInvoices.visa')}</p>
                  <div className="text-field-wrap">
                    <AntdTextField
                      setValue={setValue}
                      className="form-text-field"
                      name={`multiPaymentVisa`}
                      type="text"
                      placeholder={t('purchaseInvoices.visaPlaceholder')}
                      errorMsg={
                        errors?.multiPaymentVisa &&
                        errors.multiPaymentVisa.message
                      }
                      validateStatus={errors?.multiPaymentVisa ? 'error' : ''}
                      control={control}
                      defaultValue={
                        watch('multiPaymentCash')
                          ? renderFieldsTotalValue(watch('products')) -
                              parseFloat(watch('multiPaymentCash')) >
                            0
                            ? Math.ceil(
                                parseFloat(
                                  renderFieldsTotalValue(watch('products')) -
                                    parseFloat(watch('multiPaymentCash'))
                                ) * 100
                              ) / 100
                            : 0
                          : null
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* ./paytype section */}

        <Button
          className="submit-btn"
          htmlType="submit"
          type="primary"
          // icon={<LoginOutlined />}
          loading={isSubmittingForm}
        >
          {selectedReceipt
            ? t('purchaseInvoices.Return')
            : t('purchaseInvoices.add')}
        </Button>
      </div>
    </Form>
  );
};

export default TableFormProducts;
